import React from 'react'
import styled from "styled-components"
import Section from './Section'
const Home = () => {
    return (
        <Container>
            <Section
                title="Model S"
                description="Order Online for Touchless Delivery"
                backgroundImg="images/model-s.jpg"
            />
            <Section
                title="Model Y"
                description="Order Online for Touchless Delivery"
                backgroundImg="images/model-y.jpg"

            />
            <Section
                title="Model 3"
                description="Order Online for Touchless Delivery"
                backgroundImg="images/model-3.jpg"

            />
            <Section
                title="Model X"
                description="Order Online for Touchless Delivery"
                backgroundImg="images/model-x.jpg"

            />

            <Section
                title="Lowest Cost Solar Panels in America"
                description="Money-back Guarantee"
                backgroundImg="images/solar-panel.jpg"
            />

            <Section
                title="Solar for New Roofs"
                description="Solar roofs cost less than a New roof Plus Solar Panel"
                backgroundImg="images/solar-roof.jpg"
            />

        </Container>
    )
}

export default Home

const Container = styled.div`
height: 100vh;

`
